// extracted by mini-css-extract-plugin
export default {"recoveryPassword":"styles_recoveryPassword__kBUDn","button":"styles_button__bVKcY"};